import { CheckoutState } from '../../state';
import { getDisplayCostProps } from '../tickets/getDisplayCostProps';
import { getCalculatedShippingFees } from './getCalculatedShippingFees';
import { getOrderCosts } from './getOrderCosts';

/**
 * Selector to calculate the unformatted value of order costs
 * If order costs are present, return the total cost value
 * based on the values, as they are calculated in the backend by order service.
 * Fall back to calculating in the FE using based on selected tickets.
 *
 * @param {CheckoutState} state
 * @returns {CheckoutState.totalCostUnformatted} returns whole number such as 1500 for a $15.00 order value
 */
export const getUnformattedOrderCost = (state: CheckoutState) => {
    const orderCosts = getOrderCosts(state, true);

    if (orderCosts) {
        const shippingFee = getCalculatedShippingFees(state);
        return orderCosts.gross.value + shippingFee;
    }

    return getDisplayCostProps(state)?.totalCostUnformatted;
};
